import styled, { css } from 'styled-components';

export const CardWrapper = styled.div`
  ${({
    theme,
    isSelected,
    isDisabled,
  }) => css`
    align-items: flex-start;
    border-style: solid;
    border-width: ${isSelected ? '2px' : '1px'};
    border-color: ${isSelected ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    background-color: ${isDisabled ? theme.v2.colors.neutral.highLight : theme.v2.colors.white.primary};
    display: flex;
    width: 320px;
    padding: 24px;
    cursor: ${isDisabled ? 'auto' : 'pointer'};
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-right: 24px;
`;

export const InfoWrapper = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
`;

export const Description = styled.h4`
  ${({ theme, isDisabled }) => css`
    color: ${isDisabled ? theme.v2.colors.neutral.lowLight : theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    text-align: left;
    margin: 0 0 8px 0;
  `}
`;

export const Value = styled.span`
   ${({ theme, isDisabled }) => css`
    display: inline-block;
    color: ${isDisabled ? theme.v2.colors.neutral.lowLight : theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
   `}
`;
